import { useState } from 'react';
import { Modal, Input, message, theme } from 'antd';
import { useAnularPago } from '../api/usePagos';
import { useT } from '../../../locales';

const { TextArea } = Input;

interface AnularPagoModalProps {
  open: boolean;
  pagoId: number;
  onClose: () => void;
  onSuccess?: () => void;
}

export function AnularPagoModal({ open, pagoId, onClose, onSuccess }: AnularPagoModalProps) {
  const t = useT();
  const { token } = theme.useToken();
  const [motivo, setMotivo] = useState('');
  const anular = useAnularPago();
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    if (!motivo.trim()) {
      setError(t('pages.pagos.anularMotivoRequerido'));
      return;
    }
    setError(null);
    try {
      await anular.mutateAsync({ id: pagoId, dto: { motivo: motivo.trim() } });
      message.success(t('pages.pagos.anularSuccess'));
      onSuccess?.();
      onClose();
    } catch {
      message.error(t('pages.pagos.anularError'));
    }
  };

  return (
    <Modal
      title={t('pages.pagos.anular')}
      open={open}
      onOk={handleConfirm}
      onCancel={onClose}
      confirmLoading={anular.isPending}
      okText={t('pages.pagos.anularOk')}
      okButtonProps={{ danger: true }}
      centered
      width={520}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      <p>{t('pages.pagos.anularConfirm')}</p>
      <TextArea
        placeholder={t('pages.pagos.anularMotivoPlaceholder')}
        value={motivo}
        onChange={(e) => setMotivo(e.target.value)}
        rows={3}
        style={{ marginTop: 12 }}
      />
      {error && <p style={{ color: token.colorError, marginTop: 8 }}>{error}</p>}
    </Modal>
  );
}
